import { WalletActionCreators } from 'actions/wallet';
import { WalletRedeemStatus, WalletTransactionType } from 'constants/wallet';
import { WalletRedeemState } from 'models/wallet';

export const initialState: WalletRedeemState = {
  account: {
    bankAccountName: '',
    bankAccountNumber: '',
    bankCode: '',
    bankName: ''
  },
  accountList: {
    content: [],
    page: {
      number: 0,
      size: 0,
      totalElements: -1,
      totalPages: 0
    }
  },
  amount: 0,
  bankList: {
    content: [],
    page: {
      number: 0,
      size: 0,
      totalElements: -1,
      totalPages: 0
    }
  },
  isBankListLoading: false,
  isRedeemAccountListLoading: false,
  transaction: {
    accountId: 0,
    amount: 0,
    createdAt: '',
    currency: '',
    currentBalance: 0,
    id: '',
    subject: '',
    transactionDetails: {
      bank: {
        code: '',
        name: ''
      },
      bankAccountName: '',
      bankAccountNumber: '',
      reason: '',
      redeemStatus: WalletRedeemStatus.PENDING
    },
    transactionType: WalletTransactionType.REDEEM
  }
};

type Action = typeof WalletActionCreators[keyof typeof WalletActionCreators];

export function walletRedeemReducer(state = { ...initialState }, action: Action): typeof initialState {
  switch (action.type) {
    case WalletActionCreators.updateRedeemAccount.type:
      return { ...state, account: action.payload };
    case WalletActionCreators.updateRedeemAccountList.type:
      return { ...state, accountList: action.payload };
    case WalletActionCreators.setRedeemAccountListIsOnRequest.type:
      return { ...state, isRedeemAccountListLoading: true };
    case WalletActionCreators.setRedeemAccountListIsReceived.type:
      return { ...state, isRedeemAccountListLoading: false };
    case WalletActionCreators.updateBankList.type:
      return { ...state, bankList: action.payload };
    case WalletActionCreators.setBankListIsOnRequest.type:
      return { ...state, isBankListLoading: true };
    case WalletActionCreators.setBankListIsReceived.type:
      return { ...state, isBankListLoading: false };
    case WalletActionCreators.updateRedeemAmount.type:
      return { ...state, amount: action.payload };
    case WalletActionCreators.updateRedeem.type:
      return { ...state, transaction: action.payload };
    case WalletActionCreators.clearRedeem.type:
      return { ...initialState };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/reducers/wallet/redeem.ts